import { LegalLayout } from './LegalLayout';

export const LicensePage = () => (
  <LegalLayout title="Licença de Imagem" updated="14 de maio de 2026">
    <p>
      Resumo curto: os renders gerados são <strong>seus</strong> e podem ser usados comercialmente
      sem custos adicionais. Detalhes abaixo.
    </p>

    <h2>1. Propriedade dos modelos enviados</h2>
    <p>
      Você mantém integralmente os direitos sobre os modelos, sketches, fotos ou plantas que enviou
      ao Pórtico. Não usamos seus arquivos para treinar modelos de IA, não compartilhamos com
      terceiros e não publicamos em galerias sem sua autorização escrita explícita.
    </p>

    <h2>2. Propriedade dos renders gerados</h2>
    <p>
      Os renders gerados pelo Pórtico a partir do seu material são considerados sua obra derivada.
      Você recebe licença mundial, perpétua, irrevogável e isenta de royalties para:
    </p>
    <ul>
      <li>Usar em apresentações comerciais a clientes.</li>
      <li>Incluir em portfólio profissional, físico ou digital.</li>
      <li>Publicar em redes sociais, sites e materiais de marketing.</li>
      <li>Revender o projeto arquitetônico final junto dos renders.</li>
      <li>Imprimir em alta resolução para revistas, livros, painéis ou material editorial.</li>
      <li>Modificar, recortar, adicionar marca d'água ou pós-produzir como quiser.</li>
    </ul>

    <h2>3. Crédito ao Pórtico</h2>
    <p>
      Crédito ao Pórtico é apreciado mas não obrigatório. Se quiser mencionar,
      "Render gerado em Pórtico" funciona.
    </p>

    <h2>4. Limites de uso</h2>
    <p>Você concorda em não usar renders gerados pelo Pórtico para:</p>
    <ul>
      <li>Atribuir falsamente a outra pessoa ou estúdio.</li>
      <li>Compor conteúdo que viole direitos de imagem de terceiros (rosto reconhecível, marca de produto comercial, obra de arte protegida) sem licença adequada.</li>
      <li>Gerar conteúdo difamatório, fraudulento, discriminatório ou ilegal.</li>
      <li>Treinar outro modelo de IA generativa com os outputs do Pórtico.</li>
    </ul>

    <h2>5. Marca d'água nos renders gratuitos</h2>
    <p>
      Renders gerados nos 3 créditos gratuitos do cadastro saem com uma marca d'água discreta
      "Pórtico" no canto inferior direito. Planos pagos (Starter, Pro, Agência) entregam
      renders sem marca d'água.
    </p>

    <h2>6. Garantias e isenções</h2>
    <p>
      O Pórtico não garante exclusividade dos renders. Outros usuários podem enviar modelos
      semelhantes e obter resultados visualmente parecidos. Para uso publicitário ou editorial
      onde exclusividade visual é crítica, recomendamos modificar ou pós-produzir o render para
      garantir diferenciação.
    </p>

    <h2>7. Conteúdo de terceiros nos modelos</h2>
    <p>
      Se você enviou um modelo SketchUp que contém componentes (móveis, plantas, texturas)
      adquiridos no 3D Warehouse ou outras bibliotecas, a licença daqueles componentes continua
      regida pelos termos de quem os disponibilizou. O Pórtico apenas reinterpreta visualmente —
      não muda a situação legal do componente original.
    </p>

    <h2>8. Contato</h2>
    <p>
      Dúvidas específicas sobre licenciamento ou uso comercial em larga escala (mais de 1.000
      renders/mês ou redistribuição como produto):{' '}
      <a href="mailto:contato@portico.studio">contato@portico.studio</a>.
    </p>
  </LegalLayout>
);
